import { useState } from "react";
import LogoDiadWhite from "../../../assets/logodiadunjbgwhite.png";
import { Dropdown, Menu, message, Input, List, Avatar } from "antd";
import { MenuOutlined, UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { logout } from "../../../api/auth";
import * as SHARED from "../../../utils/shared";
import { viewFileByUrl } from "../../../utils/functions";
import FOTO_DEFAULT from "../../../assets/user_icon.png";
import { searchParticipante } from "../../../api/report";
import { Link } from "react-router-dom";

const { Search } = Input;

const handleLogout = () => {
  message.info("¡Hasta luego!");
  logout();
  window.location.reload();
};

const menu = (
  <Menu onClick={handleLogout}>
    <Menu.Item key="1" icon={<LogoutOutlined />}>
      Cerrar sesión
    </Menu.Item>
  </Menu>
);

function HeaderAdmin(props) {
  const { user, showDrawer } = props;

  const [dataToList, setDataToList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [isError, setIsError] = useState(false);
  // const [error, setError] = useState(null);

  const onSearch = async (search) => {
    if (search.length > 3) {
      try {
        const res = await searchParticipante(search);
        // console.log(res);
        setDataToList(res.payload);
      } catch (error) {
        // setError(error);
        // setIsError(true);
        setDataToList([]);
      } finally {
        setIsLoading(false);
      }
    } else {
      setDataToList([]);
    }
  };

  /**
 * 
 * try {
      setIsLoading(true);
      const res = await getByDNI(nrodocumento);

      setData(res.payload);
    } catch (error) {
      setError(error);
      setIsError(true);
      setData({});
    } finally {
      setIsLoading(false);
    }
 */

  return (
    <header
      className="flex justify-between items-center w-full h-16 p-4"
      style={{ background: "#D41D3D" }}
    >
      <span className="flex items-center">
        <span className="mr-4 md:hidden">
          <button onClick={showDrawer}>
            <MenuOutlined className="text-white" />
          </button>
        </span>
        <img src={LogoDiadWhite} width={150} alt="Logo DIAD-UNJBG" />
      </span>
      <div className="hidden md:flex w-full md:px-20 lg:px-10 md:items-center gap-4">
        <div className="flex flex-col relative w-full lg:w-1/3">
          <Search
            className="w-full bg-transparent border-0"
            style={{ background: "#D41D3D" }}
            placeholder="Buscar participante"
            allowClear
            loading={isLoading}
            onSearch={onSearch}
          />

          {!!dataToList.length && (
            <List
              className={"z-10 bg-white overflow-hidden w-full absolute top-7"}
              size="small"
              bordered
              dataSource={dataToList}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    title={
                      <Link to={"/app/participante/" + item.nrodocumento}>
                        <h4 className="hover:text-red-500 text-xs">
                          {item.nombre} {item.apellido}
                        </h4>
                      </Link>
                    }
                    avatar={
                      <Avatar
                        src={
                          item.nrodocumento
                            ? viewFileByUrl("foto_rostro", item.nrodocumento + "-FOT.jpg")
                            : FOTO_DEFAULT
                        }
                      />
                    }
                    description={<p className="text-xs">{item.nrodocumento}</p>}
                  />
                </List.Item>
              )}
            />
          )}
        </div>
        <h1 className="hidden lg:inline lg:w-2/3 text-white text-center font-semibold text-sm">
          {SHARED.TITLE_SISTEMA}
        </h1>
      </div>
      <Dropdown.Button overlay={menu} placement="bottomLeft" icon={<UserOutlined />}>
        {user.firstName || "Usuario"}
      </Dropdown.Button>
    </header>
  );
}

export default HeaderAdmin;
